<template>
<div>
    <div class="player-container">
        <audio v-if="browserName !== 'ios' && browserOs !== 'iOS'" v-bind:autoplay="isAutoPlay" @timeupdate="updateProgress" @ended="audioEnded" @playing="audioPlaying">
<!--            <source  v-bind:src="audioFile" type="audio/mpeg">-->
            <source  v-bind:src="audioFile" type="audio/mpeg">
        </audio>
        <audio v-else @timeupdate="updateProgress" @ended="audioEnded">
            <source  v-bind:src="audioFile" type="audio/mpeg">
        </audio>
        <div class="control-container">
            <div v-if="bkwSkipable === true" class="button-skipbackward" @click="skipAudioBackward"><img src="/assets/buttons/button-audio-back.svg"></div>
            <div v-if="isPlaying === false" class="button-play-pause" @click="playAudio"><img src="/assets/buttons/button-audio-play.svg"></div>
            <div v-if="isPlaying === true" class="button-play-pause" @click="pauseAudio"><img src="/assets/buttons/button-audio-pause.svg"></div>
            <div v-if="fwdSkipable === true" class="button-skipforward" @click="skipAudioForward"><img src="/assets/buttons/button-audio-next.svg"></div>
            <div class="progress-container">
                <div class="progress-indicator" v-bind:style="{width: parseInt((audioProgress / audioDuration) * 100) + '%'}"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// import configAPI from '@/config/api.json';
import config from "@/config/config.json";

export default {
    name: "AudioPlayer",
    props: ['file'],
    data() {
        return {
            configData: config,
            browserOs: null,
            browserName: null,
            audioProgress: 0,
            audioDuration: 1,
            audio: null,
            audioFile: '',
            audioLabel: '',
            isPlaying: false,
            fwdSkipable: false,
            bkwSkipable: false,
            isAutoPlay: false
        }
    },
    methods: {
        playAudio: function() {
            // console.log('playAudio');
            let player = document.querySelector('audio');
            if(player !== null) {
                this.isPlaying = true;
                player.play();
            } else {
                console.log('audio element is null!');
            }
        },
        pauseAudio() {
            // if(this.audio !== null) {
            //     this.isPlaying = false;
            //     this.audio.pause();
            // }
            let player = document.querySelector('audio');
            if(player !== null) {
                this.isPlaying = false;
                player.pause();
            }
        },
        skipAudioForward() {
            let player = document.querySelector('audio');
            if(player !== null) {
                player.currentTime = player.currentTime + 5;
            }
        },
        skipAudioBackward() {
            let player = document.querySelector('audio');
            if(player !== null) {
                if (player.currentTime > 5) {
                    player.currentTime = player.currentTime - 5;
                } else {
                    player.currentTime = 0;
                }
            }
        },
        updateProgress() {
            let player = document.querySelector('audio');
            this.audioProgress = player.currentTime;
            this.audioDuration = player.duration;
            this.bkwSkipable = true;
            if(player.duration - player.currentTime > 5) {
                this.fwdSkipable = true;
            } else {
                this.fwdSkipable = false;
            }
        },
        audioEnded() {
            this.isPlaying = false;
            this.bkwSkipable = false;
        },
        audioPlaying() {
            this.isPlaying = true;
        },
    },
    created() {
        const { detect } = require('detect-browser');
        const browser = detect();
        this.browserOs = browser.os;
        this.browserName = browser.name;

        this.audioFile = this.file;
        // console.log('audioplayer this.file: ' + this.file);
        // console.log('audioplayer this.audioFile: ' + this.audioFile);
        // testje
        this.audio = document.querySelector('audio');
        if(this.audio !== null) {
          console.log('audio element gevonden:'+this.audio.toString());
          // console.log('browser: ' + this.browserName + ' - ' + this.browserOs);
        } else {
          console.log('geen audio elementen gevonden!')
        }
    },
    beforeDestroy() {
      if(this.audio !== null) {
        this.audio.pause();
        this.audioFile = '';
        this.audio.remove();
        console.log('audio geforceerd gestopt!');
      }
    },
    mounted() {
      this.audio = document.querySelector('audio');
      if(this.audio !== null) {
          console.log('audio element gevonden:'+this.audio);
          console.log('browser: ' + this.browserName + ' - ' + this.browserOs);
      } else {
          console.log('geen audio elementen gevonden')
      }
    }
}
</script>

<style scoped>
    audio {
        width: 100%;
    }

    .player-container {
        /*position: fixed;*/
        /*bottom: 50px;*/
        /*width: 100%;*/
    }
    .control-container {
      position: relative;
      width:100%;
      height: 70%;
      background-color: #ffffff77;
      /*border: 1px solid #ffffff22;*/
      padding-top: 5px;
      padding-bottom: 5px;
    }
    .button-skipforward {
        position: absolute;
        top: 0;
        right: 5%;
        width: 60px;
        height: 55px;
    }
    .button-skipforward img {
      object-fit: fill;
      width: 100%;
      height: 100%;
    }
    .button-skipbackward {
        position: absolute;
        top: 0;
        left: 5%;
        width: 60px;
        height: 55px;
    }
    .button-skipbackward img {
      object-fit: fill;
      width: 100%;
      height: 100%;
    }
    .button-play-pause {
      width: 45px;
      height: 40px;
      margin-top: 2px;
      margin-bottom: 8px;
      margin-left: auto;
      margin-right: auto;
    }
    .button-play-pause img {
      object-fit: fill;
      width: 100%;
      height: 100%;
    }
    .progress-container {
        background-color: white;
        width: 96%;
        height: 5px;
        margin-left: 2%;
        margin-right: 2%;
        margin-top: 3px;
    }
    .progress-indicator {
        background-color: #67808A;
        height: 100%;
    }
</style>
